export enum TRANSACTION_CATEGORY {
  TRANSPORT = 'transport',
  FOOD = 'food',
  NURSERY = 'nursery',
  EDUCATION = 'education',
  INSURANCE = 'health_insurance',
  NOT_SUPPORTED = 'not_supported'
}

export enum TRANSACTION_STATUS {
  COMPLETED = 'completed',
  PENDING = 'pending',
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  DECLINED = 'declined'
}

export enum TRANSACTION_TYPE {
  CREDIT = 'credit',
  DEBIT = 'debit'
}

export enum TRANSACTION_ORIGIN {
  FR_CYCLE = 'fr_cycle',
  FR_ACCUMULATED = 'fr_accumulated',
  SB_ACCUMULATED = 'sb_accumulated',
  MIXED = 'mixed'
}

export enum TRANSACTION_KIND {
  PAYMENT = 'payment',
  REFUND = 'refund',
  FR_ACCUMULATION = 'fr_accumulation',
  SB_ASSIGNMENT = 'sb_assignment'
}

export enum WALLET_TRANSACTION_TYPE {
  TOP_UP = 'top-up',
  WITHDRAW = 'withdraw'
}

export type WithoutApproved = Exclude<TRANSACTION_STATUS, TRANSACTION_STATUS.APPROVED>;

export type FlexflowTransaction = {
  requestedAt: string;
  paidAt?: string;
  amount: number;
  name: string;
  personalId: string;
  status: TRANSACTION_STATUS;
  category: TRANSACTION_CATEGORY;
  type: TRANSACTION_TYPE;
  transactionOrigin?: TRANSACTION_ORIGIN;
  transactionKind?: TRANSACTION_KIND;
  amountFromSbAccumulated?: number;
  amountFromFrAccumulated?: number;
  amountFromFrCycle?: number;
  walletTransactionType?: WALLET_TRANSACTION_TYPE | null;
  transactionType?: TRANSACTION_TYPE;
};
